import DefaultCheckbox from 'components/Checkbox';
import RawSelectOption from 'components/RawSelectOption';
import styled from 'styled-components';

export const Container = styled(RawSelectOption)<{ isSelected: boolean }>``;

export const Checkbox = styled(DefaultCheckbox)`
  cursor: pointer;
`;
